/**
 * Centralized configuration constants.
 *
 * All environment-dependent values should be read here, not scattered
 * across components. Fallback values match production URLs.
 */

export const AUTH_API_URL =
  import.meta.env.VITE_AUTH_API_URL ?? 'https://auth-api.tem-527.workers.dev';

export const TENANT_ID =
  import.meta.env.VITE_TENANT_ID ?? 'humanizer';
